import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
import { useHistory } from "react-router-dom";
import utils from "../../components/toastify/toastify";
//locall
// import "./ShowComments.css";

const GetDays = (props) => {
  let history = useHistory();

  const [get_days_error, get_days_loading, get_days_data, get_days_function] =
    useRequest({
      method: "post",
      url: "/get_days",
      body: {
        product_id: props.match.params.product_id,
        term_id: props.match.params.term_id,
      },
    });

  const [add_day_error, add_day_loading, add_day_data, add_day_function] =
    useRequest({
      method: "post",
      url: "/add_day",
      body: {
        product_id: props.match.params.product_id,
        term_id: props.match.params.term_id,
      },
      isFunction: true,
    });

  const [
    remove_day_error,
    remove_day_loading,
    remove_day_data,
    remove_day_function,
  ] = useRequest({
    method: "post",
    url: "/remove_day",
    isFunction: true,
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <button
          onClick={() => {
            add_day_function().then(() => get_days_function().then(() => null));
          }}
          style={{ marginTop: "1rem", marginRight: "12px" }}
          type="button"
          class="btn btn-success mr-1 mb-1 "
        >
          افزودن روز جدید
        </button>
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {get_days_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">شماره روز</th>
                {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_days_data.data.map((item, index) => (
                <tr>
                  <td>{item.number}</td>
                  <td>
                    <Link
                      to={
                        "/dashboard/files/" +
                        item._id +
                        "/days/" +
                        props.match.params.term_id +
                        "/terms/" +
                        props.match.params.product_id
                      }
                    >
                      <button
                        // onClick={() => {
                        //   add_day_function().then(() => null);
                        //   get_days_function().then(() => null);
                        // }}
                        type="button"
                        class="btn btn-info round mr-1 mb-1 btn-sm"
                      >
                        فایل ها
                      </button>
                    </Link>
                    {get_days_data.data.length === index + 1 ? (
                      <button
                        onClick={() => {
                          remove_day_function({
                            product_id: props.match.params.product_id,
                            term_id: props.match.params.term_id,
                            day_id: item._id,
                          })
                            .then(() => {
                              utils.showAlert(
                                "روز با موفقیت حذف شد.",
                                "success"
                              );
                              get_days_function().then(() => null);
                            })
                            .catch(() =>
                              utils.showAlert("خطایی به وجود آمد", "error")
                            );
                        }}
                        type="button"
                        class="btn btn-danger round mr-1 mb-1 btn-sm"
                      >
                        حذف
                      </button>
                    ) : null}
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetDays };
